export const iconFontAwesomeMapsDollarSign = (
	<i className="fa-solid fa-dollar-sign"></i>
);
